import {
  AppShell,
  Button,
  Flex,
  Group,
  ScrollArea,
  Text,
} from "@mantine/core";
import { Link, Outlet, useNavigate } from "react-router";
import { Logo } from "../../../shared/ui";
import { paths } from "../../../shared/configs/paths";
import { useUnit } from "effector-react";
import { viewerEntity } from "../../../shared/entities/viewer";
import { signOut } from "supertokens-auth-react/recipe/session";
import { setSimilarityFilterModel } from "../../../features/set-similarity/model";
import { SimilarityChooseModal } from "../../../features/set-similarity";

export function MainLayout() {
  const viewerProfile = useUnit(viewerEntity.$profile);
  const openSimilaritySettingModal = useUnit(setSimilarityFilterModel.open);
  const navigate = useNavigate();

  return (
    <AppShell header={{ height: 75 }} padding="md">
      <AppShell.Header p="lg" withBorder={true}>
        <Flex justify="space-between" align="center" h="100%">
          <Flex align="center" h="60px" gap="sm">
            <Link to={paths.home} style={{ height: 60 }}>
              <Logo />
            </Link>
          </Flex>

          <Flex align="center" h="100%" gap="md">
            <Group gap={"sm"} wrap="nowrap">
              <Text size="sm" fw="500">
                {viewerProfile?.email}
              </Text>
              <Group wrap="nowrap" gap={"xs"}>
                <Button
                  variant="light"
                  onClick={() => openSimilaritySettingModal({})}
                >
                  Set Similarity
                </Button>
                <Button
                  variant="light"
                  onClick={() => {
                    signOut().then(() => {
                      navigate(paths.auth);
                    });
                  }}
                >
                  Log out
                </Button>
              </Group>
            </Group>
          </Flex>
        </Flex>
      </AppShell.Header>

      <AppShell.Main>
        <ScrollArea h="calc(var(--vh) - 100px)">
          <Outlet />
        </ScrollArea>
        <SimilarityChooseModal />
      </AppShell.Main>
    </AppShell>
  );
}
